/**
 * Discount Code object
 */
const yup = require('yup');

const {
  DiscountCodeTypes
} = require('../enums');

const {
  requiredString,
  validateObject,
  requiredInt,
  arrayOf,
  requiredEmail
} = require('../utils');

const COLLECTION = 'discountCodes';
const SCHEMA = yup.object().shape({
  slug: requiredString(),
  type: requiredString().oneOf(DiscountCodeTypes.map(type => type.value)),
  discountAmount: requiredInt(),
  credits: requiredInt(),
  restrictByEmails: arrayOf(requiredEmail()).default([]),
  restrictByPurchasables: arrayOf(requiredString()).default([])
});

async function validate(purchase) {
  return validateObject(SCHEMA, purchase);
}
/**
 * This object defines custom queries to perform on the data, outside of the normal CRUD operations
 */


const QUERIES = {
  getBySlug: slug => {
    return {
      where: [["slug", "==", slug]]
    };
  }
};
/**
 * Methods added here will trigger https-callable Cloud Functions
 */

const CALLABLES = {};
/**
 * Methods added here will be appended to each returned document from the collection
 */

const MIXINS = {};
/**
 * Dates are a bit of a pitd with Firestore, so implement this method to convert any timestamp fields to JS Date objects
 * when records are inflated from Firestore, since ultimately we need to pass Date objects back to Firestore when saving
 * records
 * @param model The inflated object from Firestore
 * @returns the model with the appropriate Timestamps converted to JS Dates
 */

const convertDates = model => {
  return model;
};

module.exports = {
  QUERIES,
  CALLABLES,
  MIXINS,
  COLLECTION,
  SCHEMA,
  validate,
  convertDates
};